import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import type { TenantSettingByKey } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class CompanySettingService {
  private readonly http = inject(HttpClient);

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getCompanySetting(settingKey: string): Observable<TenantSettingByKey> {
    return this.http
      .get(
        environment.BASE_URL +
          CONST_URL_SEGEMENTS.COMPANY_SETTING.GET_COMPANY_SETTING.replace('{setting_key}', settingKey),
        this.httpOptions,
      )
      .pipe(
        map((res: any) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }

  getCompanySettings(): Observable<TenantSettingByKey> {
    return this.http
      .get(
        environment.BASE_URL +
          CONST_URL_SEGEMENTS.COMPANY_SETTING.GET_COMPANY_SETTINGS,
        this.httpOptions,
      )
      .pipe(
        map((res: any) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }

  updateCompanySettings(data: { payload: unknown[] }) {
    return this.http
      .put(
        environment.BASE_URL +
          CONST_URL_SEGEMENTS.COMPANY_SETTING.UPDATE_COMPANY_SETTINGS,
        data,
        this.httpOptions,
      )
      .pipe(
        map((res: unknown) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }
}
